import { __extends } from "tslib";
import { somewhatImplemented, release, notImplemented, isNullOrUndefined } from '@awayfl/swf-loader';
import { ASObject } from '@awayfl/avm2';
import { SoundTransform } from './SoundTransform';
import { MovieClip as AwayMovieClip } from '@awayjs/scene';
import { AudioManager } from '@awayjs/core';
var SoundMixer = /** @class */ (function (_super) {
    __extends(SoundMixer, _super);
    function SoundMixer() {
        return _super.call(this) || this;
    }
    Object.defineProperty(SoundMixer, "bufferTime", {
        // static _audioPlaybackMode: string;
        // static _useSpeakerphoneForVoice: boolean;
        get: function () {
            release || notImplemented('public flash.media.SoundMixer::get bufferTime');
            return SoundMixer._bufferTime;
        },
        set: function (bufferTime /*int*/) {
            release || somewhatImplemented('public flash.media.SoundMixer::set bufferTime');
            SoundMixer._bufferTime = bufferTime | 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundMixer, "soundTransform", {
        get: function () {
            release || somewhatImplemented('public flash.media.SoundMixer::get soundTransform');
            return isNullOrUndefined(SoundMixer._soundTransform) ?
                new SoundTransform() :
                new SoundTransform(SoundMixer._soundTransform.volume, SoundMixer._soundTransform.pan);
        },
        set: function (sndTransform) {
            release || somewhatImplemented('public flash.media.SoundMixer::set soundTransform');
            SoundMixer._soundTransform = isNullOrUndefined(sndTransform) ?
                new SoundTransform() :
                sndTransform;
            SoundMixer._updateAllSoundSources();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundMixer, "audioPlaybackMode", {
        get: function () {
            release || notImplemented('public flash.media.SoundMixer::get audioPlaybackMode');
            return;
            // return SoundMixer._audioPlaybackMode;
        },
        set: function (_value) {
            release || notImplemented('public flash.media.SoundMixer::set audioPlaybackMode');
            return;
            // SoundMixer._audioPlaybackMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundMixer, "useSpeakerphoneForVoice", {
        get: function () {
            release || notImplemented('public flash.media.SoundMixer::get useSpeakerphoneForVoice');
            return;
            // return SoundMixer._useSpeakerphoneForVoice;
        },
        set: function (_value) {
            release || notImplemented('public flash.media.SoundMixer::set useSpeakerphoneForVoice');
            return;
            // SoundMixer._useSpeakerphoneForVoice = value;
        },
        enumerable: true,
        configurable: true
    });
    SoundMixer.stopAll = function () {
        SoundMixer._registeredSoundSources.forEach(function (e) { return e.stopSound(); });
        SoundMixer._registeredSoundSources = [];
        if (AwayMovieClip.stopAllSounds) {
            AwayMovieClip.stopAllSounds();
        }
    };
    SoundMixer.computeSpectrum = function (outputArray, _FFTMode, _stretchFactor) {
        if (_FFTMode === void 0) { _FFTMode = false; }
        if (_stretchFactor === void 0) { _stretchFactor = 0; }
        release || somewhatImplemented('public flash.media.SoundMixer::static computeSpectrum');
        var data = new Float32Array(1024);
        for (var i = 0; i < 1024; i++) {
            data[i] = Math.random();
        }
        outputArray.writeRawBytes(data);
        outputArray.position = 0;
    };
    SoundMixer.areSoundsInaccessible = function () {
        release || notImplemented('public flash.media.SoundMixer::static areSoundsInaccessible');
        return;
    };
    SoundMixer._getMasterVolume = function () {
        return SoundMixer._masterVolume;
    };
    SoundMixer._setMasterVolume = function (volume) {
        volume = +volume;
        SoundMixer._masterVolume = volume;
        SoundMixer._updateAllSoundSources();
    };
    SoundMixer._registerSoundSource = function (source) {
        SoundMixer._registeredSoundSources.push(source);
    };
    SoundMixer._unregisterSoundSource = function (source) {
        var index = SoundMixer._registeredSoundSources.indexOf(source);
        if (index >= 0) {
            SoundMixer._registeredSoundSources.splice(index, 1);
        }
    };
    SoundMixer._updateAllSoundSources = function () {
        var volume = SoundMixer._getMasterVolume();
        if (SoundMixer._soundTransform) {
            volume *= SoundMixer._soundTransform.volume;
        }
        AudioManager.setVolume(volume, -1);
    };
    // Called whenever the class is initialized.
    SoundMixer.classInitializer = null;
    // List of static symbols to link.
    SoundMixer.classSymbols = null; // [];
    // List of instance symbols to link.
    SoundMixer.instanceSymbols = null; // [];
    SoundMixer._masterVolume = 1;
    SoundMixer._registeredSoundSources = [];
    SoundMixer._bufferTime = 0;
    return SoundMixer;
}(ASObject));
export { SoundMixer };
